// extracted by mini-css-extract-plugin
export default {"tableContainer":"commonQuestions_tableContainer__I9XIw"};